import { useEffect, useState } from 'react';
import AdminLayout from '../AdminLayout';
import { getFAQsAdmin, addFAQ, updateFAQ, deleteFAQ } from '../../services/adminService';

export default function AdminFAQs() {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ question: '', answer: '' });
  const [editId, setEditId] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = () => getFAQsAdmin().then(d => { setFaqs(d); setLoading(false); });
  useEffect(() => { load(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    if (editId) {
      await updateFAQ(editId, form);
      setEditId(null);
    } else {
      await addFAQ({ ...form, order: faqs.length });
    }
    setForm({ question: '', answer: '' });
    await load();
    setSaving(false);
  };

  const handleEdit = (faq) => { setEditId(faq.id); setForm({ question: faq.question, answer: faq.answer }); };
  const handleDelete = async (id) => { if (!window.confirm('Delete FAQ?')) return; await deleteFAQ(id); setFaqs(p => p.filter(f => f.id !== id)); };

  return (
    <AdminLayout title="FAQs">
      <div className="admin-section">
        <div className="admin-section-header"><h2>{editId ? 'Edit' : 'Add'} FAQ</h2></div>
        <div className="admin-section-body">
          <form className="admin-form" onSubmit={handleSubmit} style={{ maxWidth: 600 }}>
            <div><label>Question</label><input value={form.question} onChange={e => setForm(f => ({ ...f, question: e.target.value }))} required /></div>
            <div><label>Answer</label><textarea rows={4} value={form.answer} onChange={e => setForm(f => ({ ...f, answer: e.target.value }))} required /></div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="a-btn a-btn-primary" type="submit" disabled={saving}>{saving ? 'Saving…' : editId ? 'Update FAQ' : 'Add FAQ'}</button>
              {editId && <button className="a-btn a-btn-ghost" type="button" onClick={() => { setEditId(null); setForm({ question: '', answer: '' }); }}>Cancel</button>}
            </div>
          </form>
        </div>
      </div>

      <div className="admin-section">
        <div className="admin-section-header"><h2>All FAQs ({faqs.length})</h2></div>
        <div className="admin-section-body">
          {loading ? <div className="admin-spinner">Loading…</div> : (
            faqs.length === 0 ? <div className="admin-empty">No FAQs yet</div> : (
              faqs.map((faq, i) => (
                <div key={faq.id} className="admin-list-item">
                  <div className="admin-list-item-content">
                    <strong style={{ fontSize: 14 }}>{i + 1}. {faq.question}</strong>
                    <div style={{ fontSize: 13, color: 'var(--a-text-muted)', marginTop: 4 }}>{faq.answer}</div>
                  </div>
                  <div className="admin-list-item-actions">
                    <button className="a-btn a-btn-sm a-btn-ghost" onClick={() => handleEdit(faq)}>Edit</button>
                    <button className="a-btn a-btn-sm a-btn-danger" onClick={() => handleDelete(faq.id)}>Delete</button>
                  </div>
                </div>
              ))
            )
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
